export const getInitials = (first_name: string, last_name: string) => {
  return `${first_name.charAt(0)}${last_name.charAt(0)}`;
};
